<template>
  <div id="per_center">
    <div class="nav_menu">
      <div class="nav_menu_title">
        <div class="nav_menu_title_img">
          <img src="@/assets/image/PersonalCenter/personalCenterLogo.png" alt="">
        </div>
        <div class="nav_menu_title_text">个人中心</div>
        <div><i class="el-icon-arrow-down"></i></div>
      </div>
      <div class="nav_menu_content">
        <el-menu
          router
          :default-active="this.$route.path"
          :default-openeds="defaultOpeneds"
          :unique-opened="true"
          class="nav_menu-list"
          @open="handleOpen"
          @close="handleClose">
          <!-- 我的账号 -->
          <el-menu-item index="/personalCenter/myAccount">
            <span slot="title">我的账号</span>
            <div></div>
          </el-menu-item>
<!--          &lt;!&ndash; 我是卖家 &ndash;&gt;-->
<!--          <el-menu-item index="/personalCenter/seller">-->
<!--            <span slot="title">我是卖家</span>-->
<!--            <div></div>-->
<!--          </el-menu-item>-->

          <!-- 我是卖家 -->
          <el-submenu index="seller">
            <template slot="title">
              <span>我是卖家</span>
              <div></div>
            </template>
            <el-menu-item index="/personalCenter/seller"><div></div>游戏账号</el-menu-item>
            <el-menu-item index="/personalCenter/seller/gold"><div></div>游戏金币</el-menu-item>
            <el-menu-item index="/personalCenter/seller/equip"><div></div>游戏装备</el-menu-item>
<!--            <el-menu-item index="/personalCenter/seller/bargainPrice"><div></div>收到的求降2.0</el-menu-item>
            <el-menu-item index="/personalCenter/seller/bargain"><div></div>收到的求降(老版本)</el-menu-item>-->
            <el-menu-item index="/personalCenter/seller/bargain"><div></div>收到的求降</el-menu-item>
            <el-menu-item index="/personalCenter/seller/sincerity"><div></div>我的服务订单</el-menu-item>
          </el-submenu>
<!--          &lt;!&ndash; 我是买家 &ndash;&gt;-->
<!--          <el-menu-item index="/personalCenter/buyer">-->
<!--            <span slot="title">我是买家</span>-->
<!--            <div></div>-->
<!--          </el-menu-item>-->

          <!-- 我是买家 -->
          <el-submenu index="buyer">
            <template slot="title">
              <span>我是买家</span>
              <div></div>
            </template>
            <el-menu-item index="/personalCenter/buyer"><div></div>账号订单</el-menu-item>
            <el-menu-item index="/personalCenter/buyer/gold"><div></div>金币订单</el-menu-item>
            <el-menu-item index="/personalCenter/buyer/equip"><div></div>装备订单</el-menu-item>
<!--            <el-menu-item index="/personalCenter/buyer/bargainPrice">发出的求降2.0</el-menu-item>
            <el-menu-item index="/personalCenter/buyer/bargain">发出的求降（老版）</el-menu-item>-->
            <el-menu-item index="/personalCenter/buyer/bargain">发出的求降</el-menu-item>
          </el-submenu>

          <!-- 我的收藏 -->
          <el-submenu index="myCollection">
            <template slot="title">
              <span>我的收藏</span>
              <div></div>
            </template>
            <el-menu-item index="/personalCenter/myCollection"><div></div>游戏账号</el-menu-item>
            <el-menu-item index="/personalCenter/myCollection/gold"><div></div>游戏金币</el-menu-item>
            <el-menu-item index="/personalCenter/myCollection/equip"><div></div>游戏装备</el-menu-item>
          </el-submenu>
          <!-- 咨询记录 -->
          <el-menu-item index="/personalCenter/serHistory">
            <span slot="title">咨询记录</span>
            <div></div>
          </el-menu-item>
          <!-- 最近浏览 -->
          <el-menu-item index="/personalCenter/accHistory">
            <span slot="title">最近浏览</span>
            <div></div>
          </el-menu-item>
          <el-submenu index="user_info">
            <template slot="title">
              <span>个人信息</span>
              <div></div>
            </template>
              <el-menu-item index="/personalCenter/personalInfo"><div></div>基本信息</el-menu-item>
              <el-menu-item index="/personalCenter/personalInfo/rNameAuthentication"><div></div>实名认证</el-menu-item>
              <el-menu-item index="/personalCenter/personalInfo/modifyLoginPwd"><div></div>修改登录密码</el-menu-item>
              <el-menu-item index="/personalCenter/personalInfo/withdrawalAccount"><div></div>设置提现账户</el-menu-item>
              <el-menu-item index="/personalCenter/personalInfo/paymentPwd"><div></div>支付密码</el-menu-item>
              <el-menu-item index="/personalCenter/personalInfo/changeTelphone"><div></div>换绑手机号</el-menu-item>
          </el-submenu>
          <!-- 财务中心 -->
          <el-submenu index="financial_center">
            <template slot="title">
              <span>财务中心</span>
              <div></div>
            </template>
            <el-menu-item index="/personalCenter/financialCenter"><div></div>充值</el-menu-item>
            <el-menu-item index="/personalCenter/financialCenter/withdraw"><div></div>提现</el-menu-item>
            <el-menu-item index="/personalCenter/financialCenter/withdrawRecord"><div></div>提现记录</el-menu-item>
            <el-menu-item index="/personalCenter/financialCenter/moneyDetails"><div></div>收支明细</el-menu-item>
          </el-submenu>
          <!-- 站内通知 -->
          <el-menu-item index="/personalCenter/siteNotice">
            <span slot="title" class="chatList">
              站内通知
              <span class="message" v-show="$store.state.siteNoticeMsg>0"></span>
            </span>
            <div></div>
          </el-menu-item>
          <!-- 聊天室列表 -->
          <el-menu-item index="/chat/list">
            <span slot="title" class="chatList">
              聊天室（新）
              <span class="message" v-show="this.$store.state.unReadMessage>0"></span>
            </span>
            <div></div>
          </el-menu-item>
          <!-- 聊天室列表 旧 -->
          <el-menu-item index="/chat/listOld">
            <span slot="title" class="chatList">
              聊天室
              <span class="message" v-show="this.$store.state.message>0"></span>
            </span>
            <div></div>
          </el-menu-item>
          <!-- 合同中心 -->
          <el-submenu index="contract_center">
            <template slot="title">
              <span>合同中心</span>
              <div></div>
            </template>
            <el-menu-item index="/personalCenter/contractCenter"><div></div>合同信息</el-menu-item>
          </el-submenu>
           <!-- 我的优惠券 -->
           <el-menu-item index="/personalCenter/Coupon">
            <span slot="title">我的优惠券</span>
            <div></div>
          </el-menu-item>
          <el-menu-item index="/personalCenter/Reward">
            <span slot="title">我的奖品</span>
            <div></div>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>

</template>
<script>
export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    return {

    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // if(key!='financial_center' && key !='user_info'){
      //   this.$router.push({
      //     path:keyPath[0]
      //   });
      // }
    },
    handleClose(key, keyPath) {
    }
  },
  mounted () {

  },
  watch: {

  },
  computed: {
    defaultOpeneds() {
      const path = this.$route.path
      const openMap = [
        { prefix: '/personalCenter/seller', index: 'seller' },
        { prefix: '/personalCenter/buyer', index: 'buyer' },
        { prefix: '/personalCenter/myCollection', index: 'myCollection' },
        { prefix: '/personalCenter/personalInfo', index: 'user_info' },
        { prefix: '/personalCenter/financialCenter', index: 'financial_center' },
        { prefix: '/personalCenter/contractCenter', index: 'contract_center' }
      ]
      const current = openMap.find(item => path.indexOf(item.prefix) === 0)
      return current ? [current.index] : []
    }
  }
}
</script>

<style lang='less' scoped>
.chatList{
  position: absolute;
  .message{
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: var(--hot, #FF2D55);
    position: absolute;
    top: 10px;
    right: -5px;
  }
}
#per_center{
  width: 1200px;
  min-height: max(680px, calc(100vh - 430px));
  margin-top: 14px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  background: var(--bg-page, #F7F5F2);
  border-radius: 4px;
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .nav_menu{
    width: 243px;
    flex: 0 0 243px;
    min-height: max(680px, calc(100vh - 430px));
    margin-right: 0;
    border-radius: 4px;
    background: var(--bg-dark, #1A1D24);
    border: 1px solid var(--bg-dark, #1A1D24);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
    .nav_menu_title{
      height: 72px;
      background: var(--bg-stage, #0E1116);
      border-radius: 4px 4px 0px 0px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 20px 0 26px;
      .nav_menu_title_img{
        width: 38px;
        height: 38px;
        margin-right: 10px;
        padding: 7px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.18);
        img{
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .nav_menu_title_text{
        flex: 1;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        margin-right: 0;
      }
      .el-icon-arrow-down{
        color: rgba(255, 255, 255, 0.82);
        font-size: 14px;
      }
    }
    .nav_menu_content{
      min-height: calc(100% - 72px);
      padding: 12px 10px 16px 10px;
      background: var(--bg-dark, #1A1D24);
      border-radius: 0px 0px 4px 4px;
      .nav_menu-list{
        border-right: none;
        background: transparent;
      }
      .nav_menu-list>.el-menu-item {
        height: 42px;
        line-height: 42px;
        padding-left: 44px !important;
        margin-bottom: 4px;
        position: relative;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: #c7ccd6;
        background: transparent;
        transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
        div {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
          position: absolute;
          top: 18px;
          left: 22px;
        }
      }
      .nav_menu-list>.el-menu-item.is-active,
      .nav_menu-list>.el-menu-item.is-active:hover{
        color: #FFFFFF !important;
        background: var(--primary, #FF5A1F);
        box-shadow: none;
        div{
          background: #FFFFFF;
        }
        &::before{
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: #fff;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }
      }
      .nav_menu-list>.el-menu-item:hover{
        color: #FFFFFF !important;
        background: #22262f;
        box-shadow: none;
        div{
          background: #FFFFFF;
        }
      }
      /deep/.el-menu-item, /deep/.el-submenu__title{
        height: 42px;
        line-height: 42px;
        padding-left: 44px !important;
        border-radius: 4px;
        font-size: 15px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: #c7ccd6;
        background: transparent;
        transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
      }
      /deep/.is-active>.el-submenu__title{
        color: #FFFFFF !important;
        background: #22262f;
        box-shadow: none;
        div{
          background: #FFFFFF !important;
        }
      }
      /deep/.el-submenu__title:hover,.el-submenu__title:focus{
        color: #FFFFFF;
        background: #22262f;
        div{
          background: #FFFFFF !important;
        }
      }
      /deep/.el-submenu>.el-submenu__title{
        margin-bottom: 4px;
        div{
          display: inline-block;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
          position: absolute;
          top: 18px;
          left: 22px;
        }
      }
      /deep/.el-menu--inline{
        margin: 0 0 6px 0;
        padding: 6px 0;
        border-radius: 4px;
        background: var(--bg-stage, #0E1116);
      }
      /deep/.el-menu--inline>.el-menu-item{
        height: 38px;
        line-height: 38px;
        margin: 0 6px 4px 6px;
        padding-left: 38px !important;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
      }
      /deep/.el-menu--inline>.el-menu-item:hover{
        color: #FFFFFF;
        background: #22262f;
        position: relative;
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: #FFFFFF;
          border-radius: 1px;
          top: 11px;
          left: 22px;
        }
      }
      /deep/.el-submenu>.el-menu--inline>.is-active{
        color: #FFFFFF !important;
        background: var(--primary, #FF5A1F);
        box-shadow: none;
        position: relative;
        div{
          position: absolute;
          width: 2px;
          height: 16px;
          background: #FFFFFF;
          border-radius: 1px;
          top: 11px;
          left: 22px;
        }
        &::before{
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 7px;
          height: 7px;
          background: #fff;
          clip-path: polygon(0 0, 100% 0, 0 100%);
        }
      }
      /*菜单关闭*/
      /deep/.el-submenu>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(-90deg);
        -ms-transform: rotate(-90deg);
        transform: rotateZ(-90deg);
      }
      /*菜单展开*/
      /deep/.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
        -webkit-transform: rotateZ(0deg);
        -ms-transform: rotate(0deg);
        transform: rotateZ(0deg);
      }
    }
  }
  .main{
    width: 945px;
    min-height: max(680px, calc(100vh - 430px));
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
  }
}
</style>
